/**
 * @file 表单服务
 * @author fuqiang15
 */

import FormModel from '../BaseFormModel';
import {get} from 'lodash';

export default class SchemaServiceFormModel extends FormModel {
    /**
     * @override
     */
    title = '';
    serviceType = 'schema';

    formData = {
        appId: '',
        name: '',
        mailReceiver: '',
        zipPassword: '',
        submitType: null
    };

    adaptData(data) {
        data = super.adaptData(data);
        return {
            ...data,
            mailReceiver: get(this.serviceDetail, 'data.mailReceiver'),
            zipPassword: get(this.serviceDetail, 'data.zipPassword')
        };
    }

    prepareData(data) {
        if (this.pageType === 'edit') {
            return {
                ...data,
                id: this.getRouteParams().serviceId
            };
        }
        return data;
    }
}
